import {Injectable} from '@angular/core';
import {EventInfo} from '../../models/event-info';
import {Four51Service} from '../../four51.service';
import { ApiService } from 'src/app/api.service';

@Injectable({
  providedIn: 'root'
})
export class EventWaiverService {

  constructor(private four51Service: Four51Service, private apiService: ApiService) {}

  async refresh(variantToUpdate: any, eventInfo: EventInfo, updateJpeg: boolean = true, updatePdf: boolean = false) {
    const data = {
      topicId: eventInfo.topicId,
      byoSelectedTopicId: eventInfo.byoSelectedTopicId,
      sessions: eventInfo.sessions
    };
    const variant: any = {
      ProductInteropID: 'MDVIP-EventWaiver',
      Specs: {
        fullName: {
          Value: eventInfo.fullName
        },
        data: {
          Value: JSON.stringify(data)
        }
      }
    };
    if (variantToUpdate) {
      variant.id = variantToUpdate.id;
    }

    const templateData = {};
    for (var key in variant.Specs) {
      if (variant.Specs.hasOwnProperty(key)) {
        templateData[key] = variant.Specs[key].Value;
      }
    }
    const body = {
        templateUrl: 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/event-waiver.html',
        data: templateData,
        page: 2
    };

    if (updateJpeg) {
      const jpegResponse = await this.apiService.getJpeg(body).toPromise();
      variant.PreviewUrl = jpegResponse.url;
    }
    if (updatePdf) {
      const pdfResponse = await this.apiService.getPdf(body).toPromise();
      variant.ProofUrl = pdfResponse.url;
      console.log('update pdf');
    }

    const response = await this.apiService.createVariant(variant).toPromise();
    // const response = await this.four51Service.createVariant(variant).toPromise();
    return response;
  }

}
